import axios from 'axios'

const axiosAuthInstance = axios.create({
  baseURL: `https://${process.env.REACT_APP_AUTH0_DOMAIN}`,
  timeout: 1000,

})

export default axiosAuthInstance